import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles({

  switch: {
    flexDirection: 'unset',
    marginLeft: '-4px',
    userSelect: 'none',
    width: 'fit-content'
  },

  select: {
    marginTop: '8px',
    marginBottom: '4px'
  },

})